import { Participant, User, USER_TYPES } from '@core/data/models'

const TAG_PREFIX_ESCUDERIA = 'es_'
const TAG_PREFIX_AGENCIA = 'cd_'

/**
 * Transform Participant DTO to User domain model.
 * Extracts escuderia, agencia, zona from tags array.
 *
 * @param participant - External Participant DTO from API
 * @returns User - Domain model for internal use
 */
export function userAdapter(participant: Participant): User {
  const { tags } = participant

  const escuderiaTag = tags.find(tag => tag.startsWith(TAG_PREFIX_ESCUDERIA))
  const agenciaTag = tags.find(tag => tag.startsWith(TAG_PREFIX_AGENCIA))
  const zonaTag = tags.find(tag => tag.startsWith('zona_'))

  const escuderia = escuderiaTag?.replace(TAG_PREFIX_ESCUDERIA, '')
  const agencia = agenciaTag?.replace(TAG_PREFIX_AGENCIA, '')
  const agenciaName = agencia?.replace(`_${escuderia}`, '')?.replace('_', ' ')

  const userType = tags.find(tag => Object.values(USER_TYPES).includes(tag as USER_TYPES))

  const defaultAvatar = 'https://secure.gravatar.com/avatar/f7219bbd71f453e41750fa3c63a11da1?size=64&default=mm'

  return {
    uid: participant.uid,
    authenticated: participant.authenticated ?? null,
    avatar: participant.avatar || defaultAvatar,
    name: participant.name,
    email: participant.email,
    cargo: participant.cargo || null,
    escuderiaName: escuderia!,
    agenciaName: agenciaName || null,
    zona: zonaTag || null,
    totalUsers: Number(participant.total) || 0,
    escuderia: escuderia!,
    agencia: agencia!,
    tags,
    userType: userType as USER_TYPES,
    points: participant.points,
    unconfirmed_email: participant.unconfirmed_email,
    celular: participant.celular || '',
    numero_de_documento: participant.numero_de_documento || '',
    update_file: participant.update_file,
    total_points: participant.total_points || 0
  }
}
